<header class="topbar">
  <div class="logo">
    <a [routerLink]="['/dashboard']" title="AnnuityNexus">
      <img src="assets/logo_an_annuitynexus_no_border.svg" alt="AnnuityNexus" style="height:34px;filter:brightness(0) invert(1);opacity:0.92">
    </a>
  </div>

  @if (caseCtx.activeCase(); as active) {
    <div class="case-zone">
      <button class="case-pill" type="button" (click)="togglePicker()" [attr.aria-expanded]="caseCtx.pickerOpen()">
        <span class="cp-dot" aria-hidden="true"></span>
        <span class="cp-name">{{ active.name }}</span>
        <span class="cp-crit">{{ caseSummary() }}</span>
        <span class="cp-arrow" aria-hidden="true">▾</span>
      </button>
      <div class="case-actions">
        <button class="case-btn" type="button" (click)="editCase()" title="Edit case">Edit</button>
        <button class="case-btn case-btn--danger" type="button" (click)="clearCase()" title="Clear active case">Clear</button>
      </div>
    </div>
  }

  <div class="topbar-right">
    <button class="topbar-btn" title="Notifications">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    </button>
    @if (settingsRoute(); as route) {
      @if (showAdminPill()) {
        <a class="admin-pill" title="Admin" [routerLink]="route">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
          Admin
        </a>
      } @else {
        <a class="topbar-btn" title="Settings" [routerLink]="route">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </a>
      }
    }
    <div class="av-wrap">
      <button class="av" type="button" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen()" title="Account menu">
        {{ avatarInitials() }}
        @if (isImpersonating()) {
          <span class="av-dev-dot" title="Dev mode — impersonating user" aria-hidden="true"></span>
        }
      </button>
      @if (menuOpen()) {
        <div class="av-menu" role="menu">
          <div class="av-menu-head">
            <div class="av-menu-name">{{ displayName() }}</div>
            <div class="av-menu-co">{{ companyName() }}</div>
          </div>
          <button class="av-menu-item av-menu-item--dev" type="button" role="menuitem" (click)="toggleDevPicker()">
            <span class="av-dev-pip"></span>
            Switch dev user
            @if (isImpersonating()) {
              <span class="av-menu-meta">{{ devUser.displayName() }}</span>
            }
          </button>
          @if (session.isBeaconAdmin()) {
            <button class="av-menu-item av-menu-item--dev" type="button" role="menuitem" (click)="onToggleNewShell()">
              <span class="av-dev-pip" aria-hidden="true"></span>
              Try the new shell
            </button>
          }
          <div class="av-menu-divider"></div>
          <button class="av-menu-item" type="button" role="menuitem" (click)="navigate('/account/settings')">
            Account Settings
          </button>
          <button class="av-menu-item" type="button" role="menuitem" (click)="navigate('/account/defaults')">
            Defaults for new cases
          </button>
          <button class="av-menu-item" type="button" role="menuitem" (click)="navigate('/account/shelves')">
            Custom Shelves
          </button>
          <button class="av-menu-item" type="button" role="menuitem" (click)="navigate('/account/security')">
            Security
          </button>
          <div class="av-menu-divider"></div>
          <button class="av-menu-item av-menu-item--muted" type="button" role="menuitem" (click)="signOut()">
            Sign out
          </button>
        </div>
      }
    </div>
  </div>

  @if (devPickerOpen()) {
    <div class="dev-picker-host" (click)="$event.stopPropagation()">
      <app-dev-user-picker />
    </div>
  }
</header>

<!-- The toast moved to <app-global-toast />, rendered once from app.html. It
     cannot live here: this component is the LEGACY shell's topbar, so in the
     horizontal shell there was no host and every toast was dropped. -->

